import React, { ReactNode } from 'react';
import { DefaultButton } from './Button.styles';

type StylePreset = 'primary' | 'secondary';
type ThemePreset = 'light' | 'dark' | 'special';
type SizePreset = 'large' | 'medium';
type ButtonType = 'button' | 'submit' | 'reset';

const defaultProps = {
  variant: 'primary',
  selectedTheme: 'light',
  type: 'button',
  size: 'large',
  disabled: false,
  testHook: 'Button',
  className: ''
} as Partial<ButtonProps>;

type ButtonProps = {
  variant?: StylePreset;
  selectedTheme?: ThemePreset;
  size?: SizePreset;
  type?: ButtonType;
  disabled?: boolean;
  testHook?: string;
  className?: string;
  onClick?: (e?: React.MouseEvent<HTMLButtonElement>) => void;
  children: ReactNode;
};

const Button: React.FC<ButtonProps> = ({
  variant,
  selectedTheme,
  type,
  size,
  disabled,
  testHook,
  className,
  children,
  ...props
}: ButtonProps) => (
  <DefaultButton
    variant={variant}
    selectedTheme={selectedTheme}
    size={size}
    disabled={disabled}
    data-cv-test={testHook}
    type={type}
    className={className}
    {...props}
  >
    {children}
  </DefaultButton>
);

Button.defaultProps = defaultProps;

export default Button;
